import { BenefitType } from "./benefit-type";

export class Benefit {

    id: number = 0;
    description!: string;
    benefitType: BenefitType = new BenefitType();
    attribute!: string;
    active: boolean = false;
} 